import { Link } from "react-router";
import { Container } from "@/shared/components/layout/Container";
import { Logo } from "@/shared/components/ui/Logo";
import { CookieSettingsButton } from "@/shared/components/consent/CookieSettingsButton";

const SECTION_LINKS = [
  { label: "Features", href: "#features" },
  { label: "How it works", href: "#how-it-works" },
  { label: "FAQ", href: "#faq" },
];

/**
 * Marketing footer. Brand lockup + tagline, in-page section anchors, and the
 * legal column. Per design.md §13.1 the `CookieSettingsButton` belongs in
 * footer contexts so visitors can revisit their cookie choice after the banner
 * is gone.
 */
export function MarketingFooter() {
  return (
    <footer className="border-t border-border">
      <Container
        size="lg"
        className="flex flex-col gap-10 py-16 md:flex-row md:items-start md:justify-between"
      >
        <div className="flex max-w-xs flex-col gap-4">
          <Logo to="/" />
          <p className="type-body-sm text-text-muted">
            Your guest list, beautifully organized.
          </p>
        </div>

        <nav className="flex flex-col gap-3" aria-label="Homepage sections">
          <p className="type-label-sm tracking-wider uppercase text-text-muted">
            Explore
          </p>
          {SECTION_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="type-body-base text-text-muted transition-colors hover:text-text"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex flex-col gap-3">
          <p className="type-label-sm tracking-wider uppercase text-text-muted">
            Legal
          </p>
          <Link
            to="/privacy-policy"
            className="type-body-base text-text-muted transition-colors hover:text-text"
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms-of-service"
            className="type-body-base text-text-muted transition-colors hover:text-text"
          >
            Terms of Service
          </Link>
          <Link
            to="/cookie-policy"
            className="type-body-base text-text-muted transition-colors hover:text-text"
          >
            Cookie Policy
          </Link>
          <CookieSettingsButton className="self-start px-0" />
        </div>
      </Container>

      <Container size="lg" className="border-t border-border py-6">
        <p className="type-body-sm text-text-muted">
          © Artisaire Guestbook. All rights reserved.
        </p>
      </Container>
    </footer>
  );
}
